export interface UserEmailVerificationPanelProps {
  summaryText: string,
  ctaOnClick: () => void;
  onClose: () => void;
}

export enum EmailSendErrType {
  UNKNOWN = 'unknown',
  LIMIT_CROSSED = 'limit_crossed',
  UNVERIFIED = 'unverified',
}

export const USER_EMAIL_VERIFICATION_PANEL_ID = 'user-email-verification-panel';
export const MAX_DELAY_NEXT_REQUEST_S = 60;